import { API } from 'api';
import { useMutation } from 'react-query';

interface IResetAllEmploymentBalance {
  payload: {
    eid: string;
  };
}

export const resetAllEmploymentBalance = (payload: IResetAllEmploymentBalance['payload']) =>
  API.post()(`/api/admin/${payload.eid}/reset-all-employment-balance`, {}, undefined, 60000);

export const useResetAllEmploymentBalance = () => {
  return useMutation(resetAllEmploymentBalance, {
    onSuccess: (response) => {
      return response.data;
    },
  });
};
